import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    redirectbh,
    is_phone_hk,
    convert_to_english_strhk,
    scrollTo_uphk,
    show_menu_hh,
    check_login_appbk,
    Token_get_appbk,
    FormatNumberByhkh,
    Agent_by_user_get_appbk,
    modal_select_agent_show_hide,
    Cart_get_list_product, redirectbh_typeb, modal_login_reg_bk_show, getLengt_bk, CalculateWith_tax_Percent,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';

import Master_Front from "../../pages/Master_Front";



import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import Header from "../../components/Header/Header";
import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";
import "../../assets/css/Check-out.css"
import LazyLoad from "react-lazy-load";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import logo_main from "../../assets/images/logo-web-app.svg";


const serialize = require('form-serialize');


const Checkout_post = () => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    const [address_show_box_checkout,set_address_show_box_checkout] = useState('none');

    const [checked_inperson,set_checked_inperson] = useState('checked');
    const [checked_inagent,set_checked_inagent] = useState('');


    const [checked_gateway_wallet,set_checked_gateway_wallet] = useState('checked');
    const [checked_gateway_in_place_pay,set_gateway_in_place_pay] = useState('');




    const [list_my_address,setData_list_my_address] = useState([]);
    /*  end profile */

    const [status_empty_cart,set_status_empty_cart] = useState('empty');

    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");
    const [discount_code,Set_discount_code] = useState("");
    const [discount_price,Set_discount_price] = useState("");
    const [discount_text_show,Set_discount_text_show] = useState("");
    const [data_checkoutinfo, Setdata_checkoutinfo] = useState([]);

    const [data_list_cart, Setdata_list_cart] = useState([]);

    const [title_ticket,settitle_ticket] = useState('');
    const [id_agent_checkout,set_id_agent_checkout] = useState('');

    const [data_full_get,setData_full_data_get] = useState([]);

    const [address_full,set_address_full] = useState('');
    const [title_post,set_title_post] = useState('');
    const [phone_user_address,set_phone_user_address] = useState('');

    const [shipping_cost,set_shipping_cost_address] = useState('0');

    const ModalBack = useRef();
    const Element_popups_address_new = useRef();


    useEffect(() => {
        scrollTo_uphk();
        if(check_login_appbk()==false){

            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );

            return false;
        }

        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page= () => {



        var list_products_get=[];


        try {
            list_products_get=Cart_get_list_product();
            console.log(list_products_get,"liscart2222222aaaaaaaaa")
            Setdata_list_cart(list_products_get);

            if(!empty_bk(list_products_get)){

                if(getLengt_bk(JSON.parse(list_products_get)) > 0){

                    set_status_empty_cart("notempty");

                    console.log("notempty","liscart2222222bbbbbbb")
                    console.log(getLengt_bk(list_products_get),"liscart2222222rrrrrrrrrrrr")

                } else{
                    console.log("notempty","liscart2222222cccccc")

                }




            }else{
                console.log("notempty","liscart2222222dddddddd")
                Setdata_list_cart([]);
                set_status_empty_cart("empty");

            }

        }catch (e){
            console.log("notempty","liscart2222222ddddddd")
            Setdata_list_cart([]);
            list_products_get=[];
            set_status_empty_cart("empty");

        }

        try {
            var get_agent_id="";
            get_agent_id=Agent_by_user_get_appbk("id_agent");
            set_id_agent_checkout(String(get_agent_id));
        }catch (e){
            set_id_agent_checkout("");
        }

        ////if(data_list_cart.length > 0 ){

           // const data_form = {list_products:data_list_cart,discount_code:discount_code};
            const data_form = {list_products:list_products_get,discount_code:discount_code};
            const config = {
                headers: { Authorization: `Bearer ${Token_get_appbk()}` }
            };

            Set_discount_text_show("");
        Setloadinghkfullshow("true");
            axios.post(`${clientconfigwebapp.siteurl}api/v1/check-out-get-info-post`,data_form,config)
                .then((res) => {

                    Setloadinghkfullshow("false");
                    if(String(res.data.list_my_address).length > 0) {  setData_list_my_address(res.data.list_my_address); }
                   /// console.log(res.data.list_my_address,"list_my_address22222222");

                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                    if(String(res.data.data).length > 0) {

                        console.log(res.data.data,"data_list_cart2222222222aaaaaaaaaaaa");

                        if(String(res.data.data)!="cart-empty"){



                            set_status_empty_cart("notempty");

                            console.log(status_empty_cart,"data_list_cart2222222222aaaaaaaaaaaa");


                        if(String(res.data.data[0]).length > 0) {

                            Setdata_checkoutinfo(res.data.data[0]);

                            if(!empty_bk(data_checkoutinfo.price_discount)){
                                Set_discount_price(String(data_checkoutinfo.price_discount))
                            }


                            if(!empty_bk(data_checkoutinfo.discount_text_show)){
                                Set_discount_text_show(String(data_checkoutinfo.discount_text_show));

                            }


                            if(!empty_bk(data_checkoutinfo.discount_message_box)){
                                toast.success(String(data_checkoutinfo.discount_message_box), {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            }








                        }

                        }


                    }else{
                        if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    }

                }).catch((err) =>{
                Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 345436', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            });

       /// }



    }

    function popups_address_new_OpenHandler () {
        Element_popups_address_new. current.style.right = "27%";


        ModalBack.current.style.display = "block";
    }

    function popups_address_new_CloseHandler () {
        Element_popups_address_new. current.style.right = "-93vw";
        ModalBack.current.style.display = "none";
    }

    const Handler_login_show = (event) => {
        modal_login_reg_bk_show("login_reg_check_view_modal");
    }

    const Handler_Chanche_address_full = (event) => {
        set_address_full(String(convert_to_english_strhk(event.target.value)));
    }

    const Handler_Chanche_title_post = (event) => { set_title_post(String(convert_to_english_strhk(event.target.value))); }

    const Handler_Chanche_phone_user = (event) => { set_phone_user_address(String(convert_to_english_strhk(event.target.value))); }



    const Handler_req_new_address_pr= () => {

        if(check_login_appbk()==false){ redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); }

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");


        let form_data = document.querySelector('#form_address_new');
        if (form_data != null) {

            let data_serialize = serialize(form_data);

            Setloadinghkfullshow("true");
            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/address-new-pr/`,data_serialize,config)
                .then((res) => {

                    Setloadinghkfullshow("false");

                    if(String(res.data).length > 0) {

                        if(String(res.data.data)=="login-show"){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );  }



                        if(String(res.data.status)=="success"){
                            toast.success(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                           //// redirectbh_typeb(String(clientconfigwebapp.webappurl ) + "panel/my-address");

                            Refresh_list_my_address();
                            popups_address_new_CloseHandler();
                        }else{

                            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

                        }





                    }else{
                        if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    }

                }).catch((err) =>{
                Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 6786324', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            });





        }






    }


    const show_address_box_checkout=(event)=>{

        set_address_show_box_checkout("block");
        set_checked_inperson("");
        set_checked_inagent("checked");

        event.stopPropagation();

        set_shipping_cost_address(String(data_checkoutinfo.shipping_cost));



    }

    const hide_address_box_checkout =(event)=>{

        set_checked_inperson("checked");
        set_checked_inagent("");
        set_address_show_box_checkout("none");
        ///event.preventDefault();
        event.stopPropagation();
        set_shipping_cost_address("0");

    }



    const checkbox_getway_wallet=(event)=>{


        set_gateway_in_place_pay("");
        set_checked_gateway_wallet("checked");


        event.stopPropagation();
    }

    const checkbox_getway_in_place_pay =(event)=>{

        set_checked_gateway_wallet("");
        set_gateway_in_place_pay("checked");

        event.stopPropagation();

    }

    ////const {id_post_getuser} = useParams();




    const Refresh_list_my_address= () => {


        var list_products_get=[];


        try {
            list_products_get=Cart_get_list_product();
            console.log(list_products_get,"liscart2222222aaaaaaaaa")
            Setdata_list_cart(list_products_get);

            if(!empty_bk(list_products_get)){

                if(getLengt_bk(JSON.parse(list_products_get)) > 0){

                    set_status_empty_cart("notempty");

                    console.log("notempty","liscart2222222bbbbbbb")
                    console.log(getLengt_bk(list_products_get),"liscart2222222rrrrrrrrrrrr")

                } else{
                    console.log("notempty","liscart2222222cccccc")

                }




            }else{
                console.log("notempty","liscart2222222dddddddd")
                Setdata_list_cart([]);
                set_status_empty_cart("empty");

            }

        }catch (e){
            console.log("notempty","liscart2222222ddddddd")
            Setdata_list_cart([]);
            list_products_get=[];
            set_status_empty_cart("empty");

        }

        try {
            var get_agent_id="";
            get_agent_id=Agent_by_user_get_appbk("id_agent");
            set_id_agent_checkout(String(get_agent_id));
        }catch (e){
            set_id_agent_checkout("");
        }


        const data_form = {list_products:list_products_get,discount_code:discount_code};
        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Set_discount_text_show("");
        Setloadinghkfullshow("true");
        axios.post(`${clientconfigwebapp.siteurl}api/v1/check-out-get-info-post`,data_form,config)
            .then((res) => {

                Setloadinghkfullshow("false");
                if(String(res.data.list_my_address).length > 0) {  setData_list_my_address(res.data.list_my_address); }
               /// console.log(res.data.list_my_address,"list_my_address22222222");

                if(String(res.data.data).length > 0) {


                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }



                    if(String(res.data.data[0]).length > 0) {

                        Setdata_checkoutinfo(res.data.data[0]);

                        if(!empty_bk(data_checkoutinfo.price_discount)){
                            Set_discount_price(String(data_checkoutinfo.price_discount))
                        }


                        if(!empty_bk(data_checkoutinfo.discount_text_show)){
                            Set_discount_text_show(String(data_checkoutinfo.discount_text_show));

                        }


                        if(!empty_bk(data_checkoutinfo.discount_message_box)){
                            toast.success(String(data_checkoutinfo.discount_message_box), {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        }








                    }




                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 345436', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });

    }








    const Redirect_user_togetway_saman = (token_Get,RedirectURL) => {



        var form = document.createElement("form");
        form.setAttribute("method", "POST");
        form.setAttribute("action", "https://sep.shaparak.ir/payment.aspx");
        form.setAttribute("target", "_self");
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("name", "token");
        hiddenField.setAttribute("value",String(token_Get) );
        form.appendChild(hiddenField);
        var hiddenField2 = document.createElement("input");
        hiddenField2.setAttribute("name", "RedirectURL");
        hiddenField2.setAttribute("value", String(RedirectURL));
        form.appendChild(hiddenField2);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }





    const Handlerpay_req = () => {
console.log("","liscart2222222");

        var list_products="";

        try {
            list_products=Cart_get_list_product();
            Setdata_list_cart(list_products);
            if(data_list_cart.length > 0 ){
                set_status_empty_cart("notempty");
            }else{
                set_status_empty_cart("");
            }

        }catch (e){
            set_status_empty_cart("");
        }




try {
var get_agent_id="";
get_agent_id=Agent_by_user_get_appbk("id_agent");
set_id_agent_checkout(String(get_agent_id));
}catch (e){
set_id_agent_checkout("");
}

            let form_data = document.querySelector('#form_checkout');

            if (form_data != null) {

                let data_serialize = serialize(form_data);

                Setloadinghkfullshow("true");

                const config = {
                    headers: { Authorization: `Bearer ${Token_get_appbk()}` }
                };
                Setloadinghkfullshow("true");

                axios.post(`${clientconfigwebapp.siteurl}api/v1/check-out-pay-post`,data_serialize,config)
                    .then((res) => {
                        Setloadinghkfullshow("false");
                      console.log(res.data,"ddddddataget");
                        if(String(res.data.data)=="login-show"){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );  }

                        if (!empty_bk(res.data.data)) {

                            if(String(res.data.data)!="wallet"){

                                if(res.data.get_way=="saman"){

                                    Redirect_user_togetway_saman(String(res.data.tok_way),String(res.data.RedirectURL));

                                }else if(res.data.get_way=="zarinpal"){
                                    global.window.location.href=String(res.data.data);

                                }else if(res.data.get_way=="wallet"){

                                    toast.success("سفارش با موفقیت ثبت شد", {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                                    localStorage.removeItem("cart");
                                    localStorage.removeItem("price");
                                    redirectbh_typeb(String(clientconfigwebapp.webappurl) + "panel/my-orders" );


                                }

                                if(res.data.get_way=="in_place_pay"){

                                    toast.success("سفارش با موفقیت ثبت شد", {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                                    localStorage.removeItem("cart");
                                    localStorage.removeItem("price");
                                    redirectbh_typeb(String(clientconfigwebapp.webappurl) + "panel/my-orders" );

                                    /// redirect_navigate("/panel/my-orders");
                                    /// redirect_navigate("/panel");

                                }





                            }else{

                                if(res.data.get_way=="wallet"){

                                    toast.success("سفارش با موفقیت ثبت شد", {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                                    localStorage.removeItem("cart");
                                    localStorage.removeItem("price");
                                    redirectbh_typeb(String(clientconfigwebapp.webappurl) + "panel/my-orders" );

                                   /// redirect_navigate("/panel/my-orders");
                                   /// redirect_navigate("/panel");

                                }






                            }

                        }else {
                            Setloadinghkfullshow("false");
                            toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

                        }

                    }).catch((err) =>{
                    Setloadinghkfullshow("false");
                    toast.error('خطای اتصال به سرور کد 5431', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    console.error(err, "is error 5431!");

                });



            }else{

                alert('errcode:6456546');
            }





    }


    const discont_Handler=(event)=>{
        Set_discount_code(convert_to_english_strhk(event.target.value));
    }




    const Handler_Chanche_title_ticket=(event)=>{
        settitle_ticket(convert_to_english_strhk(event.target.value));
    }


    return (
        <>
            <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}  />

                <ToastContainer />

                <div className="modal-back" ref={ModalBack}></div>



                {  String(status_empty_cart)=="notempty" ?  (

                    <Fragment>




                        <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>

                            <Grid  item className="item_inputbk" lg={9} md={9} sm={12} xs={12} style={{marginTop:"4px"}}>


                                <form id="form_checkout" name="form_checkout">

                                    <input type={"text"} name="list_products" value={data_list_cart}
                                           style={{display: "none"}}/>
                                    <input type={"text"} name="id_agent_checkout" value={id_agent_checkout}
                                           style={{display: "none"}}/>


                                    <div className="card-checkout-bk">
                                        <div style={{width: "100%"}}>
                                            <div className=""><span style={{
                                                "fontSize": "15px",
                                                "fontWeight": "normal",
                                                "paddingBottom": "4px",
                                                "borderBottom": "2px solid rgb(153 146 130)",
                                                "color": "#999282"
                                            }}>نحوه تحویل سفارش</span></div>


                                            <Grid container direction="row" spacing={2} style={{paddingTop: "40px"}}>

                                                <Grid item className="checkboxbha" lg={4} md={4} sm={6} xs={6}
                                                      style={{marginTop: "4px"}}>
                                                    <input onChange={hide_address_box_checkout} id="inperson"
                                                           name="delivery_method" type="radio" value="inperson"
                                                           checked={checked_inperson}/><label htmlFor="inperson"
                                                                                              className="whateverbhcehckbox"><span
                                                    className="">تحویل در شعبه</span></label>
                                                </Grid>

                                                <Grid item className="checkboxbha" lg={4} md={4} sm={6} xs={6}
                                                      style={{marginTop: "4px"}}>
                                                    <input onChange={show_address_box_checkout} id="inagent"
                                                           name="delivery_method" type="radio" value="inagent"
                                                           checked={checked_inagent}/><label htmlFor="inagent"
                                                                                             className="whateverbhcehckbox"><span
                                                    className="">تحویل در محل( ارسال با پیک)</span></label>
                                                </Grid>


                                            </Grid>


                                        </div>

                                    </div>


                                    <div className="card-checkout-bk" style={{display: address_show_box_checkout}}>
                                        <div style={{
                                            width: "100%",
                                            paddingBottom: 35,
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "nowrap",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}>


                                            <div className=""><span style={{
                                                "fontSize": "15px",
                                                "fontWeight": "normal",
                                                "paddingBottom": "4px",
                                                "borderBottom": "2px solid rgb(153, 146, 130)",
                                                "color": "rgb(153, 146, 130)"
                                            }}>انتخاب آدرس</span></div>

                                            <div className="">
                                                <div className="d-flex align-center" style={{float: "left"}}>
                                                    <button style={{fontFamily: 'iran'}} className="btn-bh btn-bon-bh"
                                                            type={"button"} onClick={popups_address_new_OpenHandler}>
                                                        آدرس جدید +
                                                    </button>

                                                </div>
                                            </div>
                                        </div>


                                        {list_my_address.length > 0 ? (

                                            <Fragment>

                                                <Grid container direction="row" spacing={2}
                                                      style={{paddingTop: "14px"}}>


                                                    {

                                                        list_my_address.map((item_post, index) => {

                                                            return (


                                                                <Fragment>


                                                                    <Grid item className="box_address_panel" lg={6}
                                                                          md={6} sm={12} xs={12}
                                                                          style={{marginTop: "4px"}}>

                                                                        <div className={"checkboxbha"}>
                                                                            <input
                                                                                id={"address_selected_" + String(index)}
                                                                                name="address_selected" type="radio"
                                                                                value={item_post.id_post}/>

                                                                            <label
                                                                                htmlFor={"address_selected_" + String(index)}
                                                                                className="whateverbhcehckbox">
                                                                                <span style={{
                                                                                    "fontSize": "12px",
                                                                                    "color": "#777777",
                                                                                    "fontFamily": "'iran'",
                                                                                    "display": "block",
                                                                                    "paddingBottom": "9px",
                                                                                    "width": "100%",
                                                                                    "paddingTop": "19px"
                                                                                }}> {item_post.title_post} | {item_post.phone_user_address}  </span>
                                                                                <span style={{
                                                                                    "fontSize": "12px",
                                                                                    "color": "#777777",
                                                                                    "fontFamily": "'iran'",
                                                                                    "display": "block",
                                                                                    "borderTop": "solid 1px #dbd7d7",
                                                                                    "paddingBottom": "9px",
                                                                                    "width": "100%",
                                                                                    "paddingTop": "19px"
                                                                                }}>{item_post.address_full}</span>

                                                                            </label>


                                                                        </div>

                                                                    </Grid>

                                                                </Fragment>


                                                            );

                                                        })

                                                    }


                                                </Grid>


                                            </Fragment>

                                        ) : (<Fragment>

                                            <span style={{
                                                "display": "block",
                                                "textAlign": "center",
                                                "paddingBottom": "32px",
                                                "paddingTop": "32px"
                                            }}>آدرسی ثبت نکرده اید</span>

                                        </Fragment>)}


                                    </div>


                                    <div className="card-checkout-bk">
                                        <div style={{width: "100%"}}>
                                            <div className=""><span style={{
                                                "fontSize": "15px",
                                                "fontWeight": "normal",
                                                "paddingBottom": "4px",
                                                "borderBottom": "2px solid rgb(153 146 130)",
                                                "color": "#999282"
                                            }}>نحوه پرداخت</span></div>


                                            <Grid container direction="row" spacing={2} style={{paddingTop: "40px"}}>

                                                <Grid item className="checkboxbha" lg={4} md={4} sm={6} xs={6}
                                                      style={{marginTop: "4px"}}>
                                                    <input onChange={checkbox_getway_wallet}
                                                           checked={checked_gateway_wallet} id="wallet" name="gateway"
                                                           type="radio" value="wallet"/><label htmlFor="wallet"
                                                                                               className="whateverbhcehckbox"><span
                                                    className=""><span style={{
                                                    "paddingRight": "15px",
                                                    "position": "relative",
                                                    "top": "-3px"
                                                }}>کیف پول (موجودی {FormatNumberByhkh(wallet_balance, ".", ",")} )</span></span></label>
                                                </Grid>

                                                <Grid item className="checkboxbha" lg={4} md={4} sm={6} xs={6}
                                                      style={{marginTop: "4px"}}>
                                                    <input onChange={checkbox_getway_in_place_pay}
                                                           checked={checked_gateway_in_place_pay} id="in_place_pay"
                                                           name="gateway" type="radio" value="in_place_pay"/><label
                                                    htmlFor="in_place_pay" className="whateverbhcehckbox"><span
                                                    className="">پرداخت در محل</span></label>
                                                </Grid>


                                            </Grid>



                                        </div>

                                    </div>


                                    <div className="card-checkout-bk">
                                        <div style={{width: "100%"}}>

                                            <div className=""><span style={{
                                                "fontSize": "15px",
                                                "fontWeight": "normal",
                                                "paddingBottom": "4px",
                                                "borderBottom": "2px solid rgb(153 146 130)",
                                                "color": "#999282"
                                            }}>توضیحات سفارش</span></div>

                                            <textarea style={{"marginBottom":"15px","marginTop":"23px","width":"100%","height":"96px","border":"solid 1px #ededed","backgroundColor":"#fdfdfd","fontFamily":"'iran'","padding":"9px","paddingTop":"12px"}} name={"order_description"} id={"order_description"} placeholder={"درصورتیکه توضیحاتی دارید برای سفارش خود اینجا وارد نمایید"}></textarea>

                                        </div>
                                    </div>


                                </form>

                            </Grid>


                            <Grid item className="item_inputbk" lg={3} md={3} sm={12} xs={12}
                                  style={{marginTop: "4px"}}>

                                <div className="items-factor-checkout" style={{
                                    "marginBottom": "0px",
                                    "display": "block",
                                    "padding": "16px",
                                    "background": "var(--c11)",
                                    "marginTop": "1px",
                                    "boxShadow": "rgba(0, 0, 0, 0.24) 0px 0px 2px", "borderRadius": "8px"
                                }}>

                                    <span style={{
                                        "fontSize": "15px",
                                        "fontWeight": "normal",
                                        "borderBottom": "2px solid rgb(153, 146, 130)",
                                        "color": "rgb(153, 146, 130)",
                                        "display": "inline-block",
                                        "marginBottom": "14px",
                                        "paddingBottom": "6px"
                                    }}>جزئیات سفارش</span>

                                    <div className="item-factor-checkout">مبلغ
                                        کل: {FormatNumberByhkh(data_checkoutinfo.price_main, ".", ",")} </div>

                                    <div className="item-factor-checkout"> ارزش
                                        افزوده: {FormatNumberByhkh(CalculateWith_tax_Percent(String(data_checkoutinfo.price_main), "percent_total"), ".", ",")} </div>


                                    {( shipping_cost == "0" || shipping_cost == 0 || shipping_cost === "") ? (
                                        <>
                                            <div className="item-factor-checkout"
                                                 style={{"color": "var(--c2)", "fontWeight": "bold", "fontSize": "13px"}}>
                                                مبلغ پرداختی شما: {FormatNumberByhkh(CalculateWith_tax_Percent(String(data_checkoutinfo.price), "plus_percent_total"), ".", ",")}
                                            </div>
                                        </>
                                    ) : (

                                        <>
                                            <div className="item-factor-checkout">هزینه ارسال با پیک : {FormatNumberByhkh(String(data_checkoutinfo.shipping_cost), ".", ",")} </div>

                                            <div className="item-factor-checkout"
                                                 style={{"color": "var(--c2)", "fontWeight": "bold", "fontSize": "13px"}}>
                                                مبلغ پرداختی شما: {FormatNumberByhkh( String(( parseFloat(CalculateWith_tax_Percent(String(data_checkoutinfo.price), "plus_percent_total")) + parseFloat(shipping_cost)  ))  , ".", ",")}
                                            </div>
                                        </>
                                    )}



                                    <button onClick={Handlerpay_req} className="btn-bh btn-bon-bh" type="button"
                                            style={{width: "100%", marginTop: 20}}>ثبت نهایی سفارش
                                    </button>


                                </div>


                            </Grid>


                        </Grid>


                        <section className="bk-modal-typea mini-modal-bk" style={{"paddingBottom":"20px",height:"auto"}} ref={Element_popups_address_new}>




                            <div style={{"paddingTop":"10px","paddingBottom":"10px","backgroundColor":"var(--v11)","display":"flex","marginLeft":"1%","borderRadius":"8px"}}>
                                <p  style={{"textAlign":"center","paddingTop":"11px","paddingBottom":"11px","display":"block","width":"100%","backgroundColor":"var(--v11)"}}>ثبت آدرس تحویل گیرنده سفارش</p>

                                <svg style={{"position":"relative","top":"6px","left":"12px"}} onClick={popups_address_new_CloseHandler} className="user-aside-close" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="16.392" height="2.04697" rx="1.02348" transform="matrix(0.631178 -0.775638 0.844744 0.53517 0 12.9045)" fill="#475569"/>
                                    <rect width="16.3581" height="2.05087" rx="1.02543" transform="matrix(0.617496 0.786574 -0.853256 0.521493 1.80347 0)" fill="#475569"/>
                                </svg>
                            </div>




                            <form id="form_address_new" style={{"width":"98%"}}>
                                <input type={"text"} value={"checkout"}  name={"type_req"} style={{display:"none"}}  />
                                <div className="" style={{backgroundColor: "rgb(247, 247, 255)", borderRadius: 10, border: "2px dashed rgb(206, 206, 206)", padding: 15, marginTop: 19, height: 108 }}>
                                    <span className="alert alert-warning" style={{ fontSize: 12, display: "inline-block", lineHeight: "1.6",color:"var(--8)" }}>ادرس محل تحویل سفارش را با کلیک کردن روی نقشه انتخاب کنید. (توجه نقشه بایدروی دومین اصلی سایت بیاد بالا تا لود شود،نیاز به تهیه اشتراک هستش){" "}</span>
                                </div>



                                <Grid container direction="row" spacing={2} style={{paddingTop:"9px"}}>

                                    <Grid  item className="item_address_inputbk" lg={12} md={12} sm={12} xs={12} style={{marginTop:"2px"}}>
                                        <label className="requirebk-input"  id={"address_full"} style={{"display":"block","marginBottom":"3px","marginRight":"9px"}}>آدرس دقیق</label>
                                        <input value={address_full} onChange={Handler_Chanche_address_full}  type="text" name="address_full"  style={{"direction":"rtl","width":"100%","height":"46px"}} placeholder={"آدرس تحویل سفارش"} />
                                    </Grid>

                                    <Grid  item className="item_address_inputbk" lg={6} md={6} sm={6} xs={6} style={{marginTop:"4px"}}>
                                        <label className="requirebk-input "  id={"title_ticket"} style={{"display":"block","marginBottom":"3px","marginRight":"9px"}}>عنوان آدرس</label>
                                        <input value={title_post} onChange={Handler_Chanche_title_post}  type="text" name="title_post"  style={{"direction":"rtl","width":"100%","height":"46px"}} placeholder={"مثال : شرکت"} />
                                    </Grid>


                                    <Grid  item className="item_address_inputbk" lg={6} md={6} sm={6} xs={6} style={{marginTop:"4px"}}>
                                        <label className="requirebk-input"  id={"title_ticket"} style={{"display":"block","marginBottom":"3px","marginRight":"9px"}}>شماره تماس (تحویل گیرنده)</label>
                                        <input value={phone_user_address} onChange={Handler_Chanche_phone_user}  type="text" name="phone_user_address"  style={{"direction":"rtl","width":"100%","height":"46px"}} placeholder={"مثال : 091200000"} />
                                    </Grid>






                                </Grid>



                                <button type={"button"} onClick={Handler_req_new_address_pr}  className={"btn-bh btn-black-bh"}   style={{"fontSize":"12px","marginTop":"20px","width":"100%","paddingTop":"14px","paddingBottom":"14px"}} >ثبت آدرس</button>

                            </form>



                        </section>



                    </Fragment>


                ) : (

                    <Fragment>

                        <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>

                            <Grid  item className="item_inputbk" lg={12} md={12} sm={12} xs={12} style={{marginTop:"4px"}}>


                                <div className={"message_box_login"}>
                                    <img src={logo_main} />
                                    <span>سبد خرید شما خالی است!</span>

                                    <a href={String(clientconfigwebapp.webappurl)} type={"button"} className={"btn-message_page"} >
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 122.88 112.07" style={{enableBackground: 'new 0 0 122.88 112.07',"width":"20px","height":"20px","position":"relative","top":"-2px"}} xmlSpace="preserve"><style type="text/css" dangerouslySetInnerHTML={{__html: ".st0{fill-rule:evenodd;clip-rule:evenodd;}" }} /><g><path className="st0" d="M61.44,0L0,60.18l14.99,7.87L61.04,19.7l46.85,48.36l14.99-7.87L61.44,0L61.44,0z M18.26,69.63L18.26,69.63 L61.5,26.38l43.11,43.25h0v0v42.43H73.12V82.09H49.49v29.97H18.26V69.63L18.26,69.63L18.26,69.63z" /></g></svg>
                                        <span>بازگشت به صفحه اصلی</span>
                                    </a>
                                </div>




                            </Grid>


                        </Grid>







                    </Fragment>
                )


                }





            </Master_Front>

        </>
    );
}


export default Checkout_post;